<script lang="ts" setup>
const { isMobile } = useDeviceType();
</script>

<template>
  <div :class="$style.container">
    <p :class="[$style.container__title, $style.title]">みんなの体験談</p>
    <p :class="[$style.container__lead, $style.lead]">
      実際にサービスを利用した人の<br v-if="isMobile" />リアルな声をお届けします
    </p>
    <div :class="[$style.container__cardList, $style.cardList]">
      <slot />
    </div>
    <p :class="$style.notice">
      ※本レビューの執筆に際し、謝礼をお渡ししました。この対価はレビューの執筆に対する感謝を表すものであり、レビューの内容や意見に影響を与えるものではありません<br />
      ※内容は、個々の体験や意見に基づいています。お客様の個人的な意見であり、必ずしも全ての方に当てはまるものではありません
    </p>
  </div>
</template>

<style lang="scss" module>
@use '../_constants.scss' as *;

.container {
  max-width: $content-width;
  padding: 64px 16px 0 16px;

  @include mobile-only {
    padding-top: 32px;
  }
}

.title {
  font-size: 40px;
  font-weight: bold;
  line-height: 72px;
  text-align: center;

  @include mobile-only {
    font-size: 24px;
    line-height: 43.2px;
  }
}

.lead {
  font-size: 16px;
  font-weight: bold;
  line-height: 28.8px;
  text-align: center;
  color: $color-text-and-object-accent-primary;
  @include mobile-only {
    line-height: 22.4px;
  }
}

.cardList {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 40px;

  @include mobile-only {
    grid-template-columns: 1fr;
  }
}

.notice {
  margin-top: 40px;
  font-size: 10px;
  text-align: center;
  line-height: 1.8;
  @include mobile-only {
    text-align: start;
  }
}
</style>
